(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    const view = document.querySelector(".js-view");
    const buttons = document.querySelectorAll(".js-view-inversion-button");

    // 対象が無い場合は何もしない（エラー防止）
    if (!view || buttons.length === 0) return;

    // 初期状態：-front/-back が付いていなければ -front を付与
    if (!view.classList.contains("-front") && !view.classList.contains("-back")) {
      view.classList.add("-front");
    }

    // 反転処理：front ⇄ back をトグル
    function invert() {
      const toFront = view.classList.contains("-back");
      view.classList.toggle("-front", toFront);
      view.classList.toggle("-back", !toFront);
    }

    // 複数ボタン対応
    buttons.forEach((btn) => btn.addEventListener("click", invert));
  });
})();
